module.exports = __webpack_public_path__ + "static/media/places_to_buses@x1_128.39a6138c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/places_to_buses@x1_128.gif
// module id = 181
// module chunks = 0